import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'
import React from 'react'

interface DefaultLoaderProps {
    loadingMessage?: string
}

const DefaultLoader: React.FunctionComponent<DefaultLoaderProps> = ({ loadingMessage }: DefaultLoaderProps) => {
    return (
        <div className='flex flex-col space-y-4 items-center justify-center'>
            <DynamicFaIcon iconName='spinner' className='text-3xl text-[--tb-primary]' spin />
            <span className='text-sm'>{loadingMessage || 'Loading'}</span>
        </div>
    )
}

export default DefaultLoader
